module.exports = __webpack_public_path__ + "img/moneybird.337d143b.jpg";